let db = {
  save (key, value) {
    localStorage.setItem(key, JSON.stringify(value))
  },
  get (key, defaultValue = {}) {
    if('undefined' !=localStorage.getItem(key)){
      return JSON.parse(localStorage.getItem(key))
    }
      return defaultValue
  },
  remove (key) {
    localStorage.removeItem(key)
  },
  clear () {
    localStorage.clear()
  }
}

export default db



// WEBPACK FOOTER //
// ./src/utils/localstorage.js